import React                         from 'react';
import { connect }                   from 'react-redux';
import { Link }                      from 'react-router-dom';
import { Modal}           from 'react-bootstrap';
import FlashRetornoNulo              from '../../../container/FlashRetornoNulo';
import FlashCarregando               from '../../../container/FlashCarregando';
import { SetByAceitarRecusarQuestao, 
         GetByAprovarQuestoesDuelo } from '../../../actions/questaoActions';
import {SetError}                    from '../../../actions/notificacaoAction';
import RenderLisQuestao              from '../../../container/renderListQuestao';
import { GetCheckSelect,ActionModal }            from '../../../actions/scopoAction';


class AvaliarQuestao extends React.Component {

  constructor(props){
    super(props);
    this.state = {
                  showModal : false,
                  dadosForm : [],
                  load      : false
                  };
  }

  componentWillMount(){
    this.renderQuestoes();
  }

  renderQuestoes(){

      this.props.GetByAprovarQuestoesDuelo(this.props.session.id).then((response) =>{
        this.setState({load:true});        
      }).catch((error) =>{
    		this.props.SetError(500);
      });
  }
        
  selectionAcaoAceitarRecusarQuestao(usu_id,que_id,acao,i){

        this.props.SetByAceitarRecusarQuestao(usu_id,que_id,acao).then(
          (response) =>{
              alert('Ação realizada com sucesso!');
              this.props.ActionModal(false);
              const openCollapse = `open_${i}`;
              this.setState({[openCollapse]:false});
              this.renderQuestoes();
         }
        ).catch((error) =>{
            this.props.SetError(500);
        });       
  }

  renderListAprovarAtividades(){

          const retornoQueApro = this.props.disciplinaAprovar;
    
          if(retornoQueApro.length>0) {
            return retornoQueApro.map((elem,i) =>{

                  return  <tr key={i}>
                            <td className="text-center">{elem.due_que_id}</td>
                            <td className="text-left">{elem.due_que_pergunta}</td>
                            <td className="text-center">
                             <Link to={`${this.props.config.questao}/${elem.due_que_id}`} className="btn btn-primary btn-xs"><span className="glyphicon glyphicon-pencil"></span></Link>
                            </td>        
                            <td className="text-center">
                              <button onClick={this.visulizarQuestao.bind(this,i)} className="btn btn-primary btn-xs"><span className="glyphicon glyphicon-eye-open"></span></button>
                            </td>
                          </tr>
                    });
             }else{
                return <tr> <td colSpan={4} className="text-center"><FlashRetornoNulo/></td></tr>;
             }
  }

  visulizarQuestao(val){

   const dados = this.props.disciplinaAprovar[val];

var espaco = {margin: '0 0px 0px 10px' }

     const button = [<button onClick={()=>this.props.ActionModal(false)} style={espaco} className="btn btn-primary pull-left">Fechar</button>,
                      <button onClick={this.selectionAcaoAceitarRecusarQuestao.bind(this,4,dados.due_que_id,1,val)} style={espaco} className="btn btn-primary pull-right">Aceitar  <span className="glyphicon glyphicon-thumbs-up"></span></button>,
                     <button onClick={this.selectionAcaoAceitarRecusarQuestao.bind(this,4,dados.due_que_id,0,val)} className="btn btn-primary pull-right">Recusar <span className="glyphicon glyphicon-thumbs-down"></span></button>];
    const componente  =  <RenderLisQuestao
                          pergunta = {dados.due_que_pergunta}
                          opcao_a  = {dados.due_que_opcao_a}
                          opcao_b  = {dados.due_que_opcao_b}
                          opcao_c  = {dados.due_que_opcao_c}
                          opcao_d  = {dados.due_que_opcao_d}
                          resposta = {dados.due_que_resposta}
                          button   = {button}
                        />

     this.props.ActionModal(true);

     this.setState({componente:componente})
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.actionModal){
       this.setState({showModal: true });
    }else{
       this.setState({showModal: false });
    }
}

  render(){

        if (!this.state.load) {
          return  <FlashCarregando/>;
        }

        const lar1 = {width : '5%'}
        const lar2 = {width : '10%'}

        return(
              <div>
                <div className="panel panel-azul-claro panel-cinza">
                  <div className="panel-body">
                    <table className="table table_panel">
                      <thead>
                        <tr>
                          <th className="text-center" style={lar1}>#</th>
                          <th className="text-left">Pergunta</th>
                          <th className="text-center" style={lar2}>Editar</th>
                          <th className="text-center" style={lar2}>Visualizar</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.renderListAprovarAtividades()}
                      </tbody>
                    </table>
                  </div>
                </div>
                <Modal show={this.state.showModal} bsSize="large" backdrop="static">
                  {this.state.componente}
                </Modal>
              </div>
            );
    }

}

function mapStateToProps(state){

    return {
        session           : state.auth.session,
        disciplinaAprovar : state.questaoReducer.allQuestaoAprovar,
        actionModal       : state.scopoReducer.actionModal,
        config            : state.configReducer.menu
    }

}

export default connect(mapStateToProps,{ SetByAceitarRecusarQuestao, GetByAprovarQuestoesDuelo, GetCheckSelect, ActionModal, SetError})(AvaliarQuestao);



// WEBPACK FOOTER //
// ./src/components/professor/batalha/batalha_list_aprovar_questao.js